"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyCategory$ = exports.CompaniesCompanyCategory$outboundSchema = exports.CompaniesCompanyCategory$inboundSchema = exports.CompaniesCompanyCategory = void 0;
const z = __importStar(require("zod"));
exports.CompaniesCompanyCategory = {
    ScottishCharitableIncorporatedOrganisation: "Scottish Charitable Incorporated Organisation",
    RegisteredSociety: "Registered Society",
    ScottishPartnership: "Scottish Partnership",
    PrivateUnlimitedCompany: "Private Unlimited Company",
    InvestmentCompanyWithVariableCapitalUmbrella: "Investment Company with Variable Capital(Umbrella)",
    OldPublicCompany: "Old Public Company",
    FurtherEducationAndSixthFormCollegeCorps: "Further Education and Sixth Form College Corps",
    LimitedPartnership: "Limited Partnership",
    IndustrialAndProvidentSociety: "Industrial and Provident Society",
    PublicLimitedCompany: "Public Limited Company",
    CommunityInterestCompany: "Community Interest Company",
    PRILBGNSCPrivateLimitedByGuaranteeNoShareCapitalUseOfLimitedExemption: "PRI/LBG/NSC (Private, Limited by guarantee, no share capital, use of 'Limited' exemption)",
    OverseasEntity: "Overseas Entity",
    LimitedLiabilityPartnership: "Limited Liability Partnership",
    PRILTDBYGUARNSCPrivateLimitedBYGuaranteeNoShareCapital: "PRI/LTD BY GUAR/NSC (Private, limited by guarantee, no share capital)",
    ConvertedClosed: "Converted/Closed",
    ProtectedCellCompany: "Protected Cell Company",
    CharitableIncorporatedOrganisation: "Charitable Incorporated Organisation",
    OtherCompanyType: "Other Company Type",
    PrivateLimitedCompany: "Private Limited Company",
    RoyalCharterCompany: "Royal Charter Company",
    InvestmentCompanyWithVariableCapital: "Investment Company with Variable Capital",
    UnitedKingdomEconomicInterestGrouping: "United Kingdom Economic Interest Grouping",
    PRIVLTDSECT30PrivateLimitedCompanySection30OfTheCompaniesAct: "PRIV LTD SECT. 30 (Private limited company, section 30 of the Companies Act)",
    UnitedKingdomSocietas: "United Kingdom Societas",
    InvestmentCompanyWithVariableCapitalSecurities: "Investment Company with Variable Capital (Securities)",
    PrivateUnlimited: "Private Unlimited",
    CommunityBenefitSociety: "Community Benefit Society",
    CoOperativeSociety: "Co-operative Society",
    FriendlySociety: "Friendly Society",
    BuildingSociety: "Building Society",
    BenevolentSociety: "Benevolent Society",
    CreditUnion: "Credit Union",
    LoanSociety: "Loan Society",
    SpeciallyAuthorisedSociety: "Specially Authorised Society",
    SuperAnnuation: "Super Annuation",
    WorkingMenSClub: "Working Men's Club",
};
/** @internal */
exports.CompaniesCompanyCategory$inboundSchema = z.nativeEnum(exports.CompaniesCompanyCategory);
/** @internal */
exports.CompaniesCompanyCategory$outboundSchema = exports.CompaniesCompanyCategory$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyCategory$;
(function (CompaniesCompanyCategory$) {
    /** @deprecated use `CompaniesCompanyCategory$inboundSchema` instead. */
    CompaniesCompanyCategory$.inboundSchema = exports.CompaniesCompanyCategory$inboundSchema;
    /** @deprecated use `CompaniesCompanyCategory$outboundSchema` instead. */
    CompaniesCompanyCategory$.outboundSchema = exports.CompaniesCompanyCategory$outboundSchema;
})(CompaniesCompanyCategory$ || (exports.CompaniesCompanyCategory$ = CompaniesCompanyCategory$ = {}));
//# sourceMappingURL=companiescompanycategory.js.map